export default "__VITE_ASSET__DV3Bn81v__"